console.log = function () { }

let envs = [];
let env = "production";

envs['development'] = {
    baseApiUrl: "http://localhost:5000/api/",
    clientUrl: "http://localhost:4200/",
    platFormUrl: "https://workspace.platform-oms.co.uk/file-server/",
    bucket: "aegis-cert",
    region: "eu-west-2",
    companyName: 'Aegis Certification'
}

envs['testing'] = {
    baseApiUrl: "https://aegis-cert.platform-oms.co.uk/api/",
    clientUrl: "https://aegis-cert.platform-oms.co.uk/",
    platFormUrl: "https://workspace.platform-oms.co.uk/file-server/",
    bucket: "aegis-cert",
    region: "eu-west-2",
    companyName: 'Aegis Certification'
}

envs['production'] = {
    baseApiUrl: 'https://aegis-cert.platform-oms.co.uk/api/',
    clientUrl: "https://aegis-cert.platform-oms.co.uk/",
    platFormUrl: "https://workspace.platform-oms.co.uk/file-server/",
    bucket: "aegis-cert",
    region: "eu-west-2",
    companyName: 'Aegis Certification'
}

export const config = envs[env];